import H2 from "components/atoms/H2"
import useTranslations from "hooks/useTranslations"
import { ResponseImage } from "./images"

/**
 * "Designed to complement your current setup."
 *
 * ⚠️ Essi's note on this section reads "INFO ABOUT EASY INTEGRATIONS WITH
 * CPOMS; SKOLON ETC". No such integration exists in the product as far as the
 * code shows, so no named integration appears here and the copy stays at the
 * level Essi wrote it. Name CPOMS or Skolon only once someone confirms an
 * integration actually ships.
 */
export default function UkIntegrations() {
  const { ukSchoolsIntegrationsTitle, ukSchoolsIntegrationsText } =
    useTranslations()

  return (
    <div className="bg-white py-16 lg:py-24">
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-y-10 lg:grid-cols-2 lg:gap-x-16">
          <div className="space-y-6">
            <H2
              size="lg"
              className="m-0 whitespace-pre-line text-left font-extrabold tracking-tight"
              theme="light"
            >
              {ukSchoolsIntegrationsTitle}
            </H2>
            <p className="m-0 text-base leading-relaxed text-zinc-700 lg:text-lg">
              {ukSchoolsIntegrationsText}
            </p>
          </div>
          <div className="overflow-hidden rounded-l-full">
            <ResponseImage className="h-64 w-full lg:h-80" />
          </div>
        </div>
      </section>
    </div>
  )
}
